var React = require('react');

function StreamlineLine35CameraBox (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"M8.182 7.5l2.183-2h3.271l2.183 2H19c.825 0 1.5.856 1.5 1.682V16c0 .825-.675 1.5-1.5 1.5H5c-.825 0-1.5-.675-1.5-1.5V9.182C3.5 8.356 4.175 7.5 5 7.5h3.182z","key":0}),React.createElement("path",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","d":"M23.5 19.5c0 2.2-1.8 4-4 4h-15c-2.2 0-4-1.8-4-4v-15c0-2.2 1.8-4 4-4h15c2.2 0 4 1.8 4 4v15z","key":1}),React.createElement("path",{"d":"M17.5 10c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z","key":2}),React.createElement("circle",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"12","cy":"11.75","r":"2.75","key":3}),React.createElement("g",{"key":4},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine35CameraBox.displayName = "StreamlineLine35CameraBox";

StreamlineLine35CameraBox.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine35CameraBox;

StreamlineLine35CameraBox.default = StreamlineLine35CameraBox;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-35-camera-box.svg
// module id = 767
// module chunks = 0